/**
 * Состояние линии в шапке пульта.
 *
 * «Нет линии» — не косметика: пока регистрации нет, сервер перестаёт раздавать
 * контакты этому диспетчеру (§7.9), и он должен понимать, почему пульт пуст.
 */

import type { LineState } from '@cc/softphone-core';

const TITLES: Record<LineState, string> = {
  offline: 'Линия выключена',
  connecting: 'Подключаюсь к станции',
  registered: 'Линия готова',
  line_down: 'Нет линии — звонки не пройдут',
};

const DOTS: Record<LineState, string> = {
  offline: 'bg-slate-400',
  connecting: 'bg-amber-500',
  registered: 'bg-emerald-600',
  line_down: 'bg-red-600',
};

export interface LineIndicatorProps {
  line: LineState;
  isLeaderTab: boolean;
}

export function LineIndicator({ line, isLeaderTab }: LineIndicatorProps): React.JSX.Element {
  return (
    <div className="flex items-center gap-2 text-sm text-slate-700">
      <span className={`h-2.5 w-2.5 rounded-full ${DOTS[line]}`} aria-hidden />
      <span>{TITLES[line]}</span>
      {!isLeaderTab ? (
        <span className="rounded bg-slate-100 px-2 py-0.5 text-xs text-slate-600">
          Пульт открыт в другой вкладке
        </span>
      ) : null}
    </div>
  );
}
